import { useNavigate, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderId = params.get("order_id");

  return (
    <div className="max-w-md mx-auto px-5 py-16 text-center pb-32">
      <div className="mx-auto w-24 h-24 rounded-full bg-red-100 flex items-center justify-center">
        <XCircle className="w-14 h-14 text-red-500" />
      </div>
      <h1 className="mt-6 font-display text-3xl font-bold">Payment cancelled</h1>
      <p className="mt-2 text-neutral-500">No worries — your cart is still saved. Try again whenever you're ready.</p>
      <div className="mt-6 flex flex-col gap-2">
        <button data-testid="retry-checkout-btn" onClick={() => navigate("/cart")} className="btn-primary">Back to cart</button>
        {orderId && (
          <button onClick={() => navigate(`/track/${orderId}`)} className="text-sm text-neutral-500 hover:text-eatup-charcoal">View order</button>
        )}
      </div>
    </div>
  );
}
